import { BindingPath, ViewModelFieldName } from "../CoreTypes";
import { IFetchFunctionCallContext } from "../../Form/CustomizationContexts/FetchFunctionContext/FetchFunctionCallContext";
import { assertIs } from "../../../../../Common/TypingUtils";
import type { DataDeclarationFields } from "../../../../../Generator/src/generators/DataDeclarationGenerator/DataDeclaration";
import { SectionDeclaration } from "../../../../../Generator/src/generators/DataDeclarationGenerator/DataDeclaration";
import { RngSchemeTypes } from "../../../../../Common/RngSchemeTypes/types";

type FetchFunction = (this: IFetchFunctionCallContext, nodePath: BindingPath) => undefined | string | string[];

export type NodeFieldValueSources = NodeFieldValueSource[];

export type ConstValueSource = string | string[] | boolean;

export interface TakeFromModelValueSource {
    model: true | string;
}

export interface FetchFunctionValueSource {
    fn: FetchFunction;
    fnName?: string;
    fnPropName?: string;
}

export type NodeFieldValueSource = ConstValueSource | TakeFromModelValueSource | FetchFunctionValueSource;

export function isConstValueSource(valueSource: NodeFieldValueSource): valueSource is ConstValueSource {
    return typeof valueSource !== "object" || Array.isArray(valueSource);
}

export function isTakeFromModelValueSource(valueSource: NodeFieldValueSource): valueSource is TakeFromModelValueSource {
    return typeof valueSource === "object" && "model" in valueSource && valueSource.model !== undefined;
}

export function isFetchFunctionValueSource(valueSource: NodeFieldValueSource): valueSource is FetchFunctionValueSource {
    return typeof valueSource === "object" && "fn" in valueSource && valueSource.fn !== undefined;
}

export interface NodeDataDeclaration {
    autoFlag?: NodeFieldValueSources;
    optionalSections?: SectionDeclaration[];
    allSingleSections?: SectionDeclaration[];
    children?: NodeFieldValueSources;
    optional?: NodeFieldValueSources;
    disabled?: NodeFieldValueSources;
    section?: NodeFieldValueSources;
    value?: NodeFieldValueSources;
    fnsConvertFileExtentions?: NodeFieldValueSources;
    errorAndWarningCountRequired?: [boolean];
    hasDisableValueAutoInitFlag?: boolean;
    type?: RngSchemeTypes;
    useServerFilters?: boolean;
}

export function isAttributeRequireNormalization(fieldName: DataDeclarationFields): boolean {
    if (
        fieldName !== "maxOccurs" &&
        fieldName !== "optionalSections" &&
        fieldName !== "allSingleSections" &&
        fieldName !== "section" &&
        fieldName !== "optional" &&
        fieldName !== "fnsConvertFileExtentions" &&
        fieldName !== "title" &&
        fieldName !== "ctrlType" &&
        fieldName !== "value_bind" &&
        fieldName !== "multiple" &&
        fieldName !== "exist_bind" &&
        fieldName !== "visible" &&
        fieldName != "errorAndWarningCountRequired" &&
        fieldName != "type" &&
        fieldName != "hasDisableValueAutoInitFlag" &&
        fieldName != "useServerFilters" &&
        fieldName != "pageId"
    ) {
        // Проверка чтобы во ViewModel не прилетали лишние поля
        assertIs<ViewModelFieldName>(fieldName);
        return true;
    }
    return false;
}

export interface DataDeclaration {
    [path: string]: NodeDataDeclaration;
}
